import { z } from 'zod';
import { FeaturesSchema } from './features';

export const PlanEntitlementsSchema = z.object({
    credits: z.number().int().nonnegative(),
    features: FeaturesSchema
});
export type PlanEntitlements = z.infer<typeof PlanEntitlementsSchema>;